export default __webpack_public_path__ + "assets/images/listen-bg-0d26f830.jpg";